var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CSpinner',{staticStyle:{"background-color":"#668ab5","border-color":"#668ab5"},attrs:{"type":"grow","label":"Loading"}})}
var staticRenderFns = []

export { render, staticRenderFns }